module.exports = __webpack_public_path__ + "static/media/JosephOliver2.4758f151.docx";